const dataUpload = {
  wizard: {
    fileUpload: {
      title: '1. Carregar arquivo CSV',
      subTitle: 'Escolha o arquivo relevante',
      body: {
        title: 'Arquivo CSV',
        btn: 'Carregar',
        downloadExample: 'Baixar exemplo de CSV',
        templateLabel: 'Selecionar modelo de mapeamento (opcional)',
        templateDescription: 'Modelo carregado. Você pode visualizar ou editar a configuração abaixo, se necessário.',
      },
    },
    mappingFields: {
      title: '2. Mapeamento de Campos',
      subTitle: 'Confirme se cada atributo corresponde à coluna correta',
      toast: 'Valor duplicado',
      selectInputPlaceHolder: 'Selecione a zona'
    },
    integrityCheck: {
      title: '3. Verificação de Integridade',
      subTitle: 'Verificando os valores dos arquivos',
    },
    import: {
      title: '4. Importar',
      subTitle: 'Importe os dados',
      doneText: 'O arquivo foi importado',
      doneBtn: 'Ok',
    },
  },

  mappingFields: {
    table: {
      fieldsInDb: 'Campos do BD',
      csvFile: 'Arquivo CSV',
      format: 'Formatar',
      defaultValue: 'Valor Padrão',
    },
    hideTableBtn: 'Ocultar tabela',
    showTableBtn: 'Mostrar tabela',
    saveAsTemplateBtn: 'Salvar como modelo',
    templateNameLabel: 'Nome do modelo',
    saveTemplateDescription: 'Salve seus mapeamentos de campo atuais como um modelo para uso futuro.',
    updateTemplateDescription: 'Você pode atualizar o modelo existente {{templateName}} ou salvar como um novo modelo.',
    saveTemplateBtn: 'Salvar',
    saveAsNewBtn: 'Salvar como novo',
    updateTemplateBtn: 'Atualizar modelo',
    nextBtn: 'Próximo',
  },

  integrityCheck: {
    showOnlyProblemBtn: 'Mostrar apenas problemas',
    disableSubmit: 'Pular Erros',
    totalCount: 'Total: {{count}}',
    exportErrorList: 'Exportar Lista de Erros',
    rowContainErroe: '{{count}} A linha contém erro.',
    importBtn: 'Importar'
  },

  submit: {
    errors: 'Falha ao ser movido',
  }
};

export default dataUpload;
